// src/contexts/token/useTokenFundamentals.ts
/**
 * Hooks for TokenFundamentalsContext
 * Separated for Fast Refresh compatibility
 */

import { useContext } from "react";
import { TokenFundamentalsContext } from "./TokenFundamentalsProvider";
import type { TokenFundamentalsContextValue } from "./types";

export function useTokenFundamentals(): TokenFundamentalsContextValue {
  const context = useContext(TokenFundamentalsContext);
  if (!context) {
    throw new Error("useTokenFundamentals must be used within a TokenFundamentalsProvider");
  }
  return context;
}

export function useTokenFundamentalsOptional(): TokenFundamentalsContextValue | null {
  return useContext(TokenFundamentalsContext);
}

